<template>
<div class="chapter">
<div class="inner_page">
<p class="head2"><a id="page_xvi"><span class="small">MAPS</span></a></p><a id="page_xvi">
<p class="image" id="map1"><img alt="image" src="images/map.jpg"/></p>
<p class="caption">Map 1. Justinian’s empire, ca. 565.</p>
</a><p class="image" id="map2"><a id="page_xvi"></a><a id="page_xvii"><img alt="image" src="images/map2.jpg"/></a></p><a id="page_xvii">
<p class="caption">Map 2. The Byzantine empire, ca. 1025.</p>
</a><p class="image" id="map3"><a id="page_xvii"></a><a id="page_xviii"><img alt="image" src="images/map3.jpg"/></a></p><a id="page_xviii">
<p class="caption">Map 3. Byzantium, ca. 1350.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// map.vue?0e1e4f42